const SITE_URL = 'https://www.sarahojewelry.com/';
window.SITE_URL = SITE_URL;

function performRedirect() {

    const pathname = window.location.pathname;

    if (pathname.includes('/account')) {
        return;
    }

    if (pathname.includes('/challenge')) {
        return;
    }

    if (pathname.includes('/pages/login-success')) {
        return;
    }

    if (pathname.includes('/products_preview')) {
        // handled in prod template
        return;
    }

    if (pathname.includes('/products/')) {
        const prodSlug = window.location.pathname.split('/products/')[1];
        window.location.replace(`${SITE_URL}/products/${prodSlug}`);
        return;
    }

    switch (pathname) {
        //case '/account/login':
        //case '/challenge':
        //    break;
        //case '/':
        //case '/cart':
        //    window.location.replace('https://from=' + pathname);
        //    break;
        default:
            window.location.replace(`${SITE_URL}/?from=${pathname}`);
            break;
    }
}

performRedirect();